<div class="textarea-container mb-4">
  <label
    *ngIf="label"
    [attr.for]="name"
    class="form-label d-flex align-items-center"
  >
    {{ label }}
    <sup *ngIf="required && !hideRequiredStar" class="text-danger">*</sup>
    <i-feather
      *ngIf="helpText"
      name="Info"
      [attr.title]="helpText"
      class="help-icon"
    ></i-feather>
  </label>

  <div class="input-group">
    <textarea
      [name]="name"
      [attr.id]="name"
      [(ngModel)]="value"
      (ngModelChange)="onChanged($event)"
      (focus)="markAsTouched()"
      (blur)="markAsTouched()"
      [class.is-invalid]="formControl.touched && !formControl.valid"
      [ngClass]="classes"
      [autocomplete]="autocomplete"
      [disabled]="disabled"
      [placeholder]="placeholder ? placeholder : ''"
      [attr.tabindex]="tabindex"
      class="form-control"
      [attr.rows]="rows"
      [attr.maxlength]="maxLength"
    ></textarea>
    <div *ngIf="withRightIcon" class="input-group-append">
      <span class="input-group-text" style="cursor: pointer">
        <ng-content select="[rightIcon]"></ng-content>
      </span>
    </div>
    <ng-content select="[body]"></ng-content>
  </div>

  <p *ngIf="maxLength" class="small mt-1 counter">
    {{ value.length || 0 }} / {{ maxLength }}
  </p>

  <p
    *ngIf="description"
    [hidden]="formControl.touched && !formControl.valid"
    class="text-muted"
  >
    <small>{{ description }}</small>
  </p>

  <p
    [hidden]="!(formControl.touched && !formControl.valid)"
    class="text-danger"
  >
    <small>{{ errorMessage }} </small>
  </p>
</div>
